import * as CartJS from 'shopify-cartjs';

import { selectors } from './Constants';
import CartCounter from './component/cart/CartCounter';
import EmbeddedProduct from './component/EmbeddedProduct';
import EmbeddedQuiz from './component/EmbeddedQuiz';

import 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

const data = JSON.parse(document.body.querySelector('[data-theme-data]').innerHTML);
global.CartJS = CartJS;

// @ts-ignore
CartJS.init(data.cart, {
  dataAPI: false,
  requestBodyClass: 'cart-loading',
});

const initCartCounters = () => {
  const cartCounters = document.querySelectorAll(selectors.page.cartCounter);

  cartCounters.forEach((cc) => {
    // eslint-disable-next-line no-new
    new CartCounter(cc, data.cart.items);
  });
};

const initProductEmbeds = () => {
  const productEmbeds = document.querySelectorAll(selectors.product.embed);

  productEmbeds.forEach((productEmbed) => {
    // eslint-disable-next-line no-new
    new EmbeddedProduct(productEmbed as HTMLElement);
  });
};

const initQuizEmbeds = () => {
  const quizEmbeds = document.querySelectorAll(selectors.page.plantQuizEmbed);

  quizEmbeds.forEach((quizEmbed) => {
    // eslint-disable-next-line no-new
    new EmbeddedQuiz(quizEmbed as HTMLElement);
  });
};

const announcementBarMutationObserver = () => {
  const docEl = document.documentElement;

  const observer = new MutationObserver((mutations: MutationRecord[]) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const announcementBar = document.querySelector('.essential_annoucement_bar_wrapper');

            if (announcementBar) {
              document.documentElement.style.setProperty('--site-announcement-bar-height',
                `${(announcementBar as HTMLElement).offsetHeight}px`);

              observer.disconnect();
            }
          }
        });
      }
    });
  });

  observer.observe(docEl, {
    childList: true, subtree: true,
  });
};

const initCssVars = () => {
  const ribbonEl = document.querySelector('.ribbon') as HTMLElement;
  const siteCountDownTimer = document.querySelector('.hc_cd.at_top') as HTMLElement;
  const announcementBar = document.querySelector('.essential_annoucement_bar_wrapper') as HTMLElement;

  if (ribbonEl) {
    document.documentElement.style.setProperty('--site-promo-height', `${ribbonEl.offsetHeight}px`);
  } else {
    document.documentElement.style.setProperty('--site-promo-height', '0px');
  }

  if (siteCountDownTimer) {
    document.body.style.marginTop = '0px';
    document.documentElement.style.setProperty('--site-countdown-timer-height', `${siteCountDownTimer.offsetHeight}px`);
  }

  if (announcementBar) {
    document.documentElement.style.setProperty('--site-announcement-bar-height', `${announcementBar.offsetHeight}px`);
  } else {
    announcementBarMutationObserver();
  }
};

const init = () => {
  // initCartToggle();
  initCartCounters();
  initProductEmbeds();
  initQuizEmbeds();
  initCssVars();
};

init();
